/*
 * @Author: yy
 * @Date: 2021-10-25 17:13
 * @Last Modified by: yy
 * @Last Modified time: 2021-10-25 17:13
 */
import Form from './form.vue';

export default Form;
